// menu new:
export const menus = [
  {
    level: 1,
    title: 'categories',
    open: true,
    selected: false,
    disabled: false,
    children: [
      {
        level: 2,
        title: 'By industry',
        icon: 'industry2Icon',
        link: 'by-industry',
        open: false,
        selected: false,
        disabled: false,
        children: [
          { level: 3, selected: false, disabled: false, title: 'Accounting & Financial', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Education, Training & Staffing', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Home Products & Services', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Restaurant Franchises', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Advertising & Marketing', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Employment & Staffing', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Industrial Franchises', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Retail Franchises', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Automotive', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Entertainment Franchises', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Internet and Technology', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Senior care & Healthcare', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Business Opportunities', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Financial Services', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Mailing & Shipping', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Sports & Recreation', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Business Services', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Food & Restaurants', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Moving & Storage', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Tax Franchises', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Children\'s Franchises', link: '/ ', fire: true },
          { level: 3, selected: false, disabled: false, title: 'Franchise Resales', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Pet Franchises', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Training Franchises', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Cleaning and Maintenance', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Franchise Service Providers', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Photography Franchises', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Travel, Cruise and Hotel', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Coffee Franchises', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Health & Beauty', link: '/', fire: true },
          { level: 3, selected: false, disabled: false, title: 'Post-COVID Franchises', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Vending & ATM Franchises', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Computer & Internet', link: '/', fire: true },
          { level: 3, selected: false, disabled: false, title: 'Health Personal Care & Fitness', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Printer, Copying & Sign', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Consultants & Business Brokers', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Home based and/or Mobile', link: '/' },
          { level: 3, selected: false, disabled: false, title: 'Real Estate Franchises', link: '/', fire: true },
        ],
      },
      {
        level: 2,
        title: 'By Location',
        icon: 'locationIcon',
        link: 'location',
        selected: true,
        disabled: false,
        children: [
          { level: 3, selected: false, disabled: false, title: 'Alabama', link: '/location/alabama'},
          { level: 3, selected: false, disabled: false, title: 'Hawaii', link: '/location/hawaii'},
          { level: 3, selected: false, disabled: false, title: 'Massachusetts', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'New Mexico', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'South Dakota', link: '/', fire: true },
          { level: 3, selected: false, disabled: false, title: 'Alaska', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Idaho', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Michigan', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'New York', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Tennessee', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Arizona', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Illinois', link: '/', fire: true },
          { level: 3, selected: false, disabled: false, title: 'Minnesota', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'North Carolina', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Texas', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Arkansas', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Indiana', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Mississippi', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'North Dakota', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Utah', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'California', link: '/', fire: true },
          { level: 3, selected: false, disabled: false, title: 'Iowa', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Missouri', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Ohio', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Vermont', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Colorado', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Kansas', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Montana', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Oklahoma', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Virginia', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Connecticut', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Kentucky', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Nebraska', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Oregon', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Washington', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Delaware', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Louisiana', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Nevada', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Pennsylvania', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'West Virginia', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Florida', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Maine', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'New Hampshire', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Rhode Island', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Wisconsin', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Georgia', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Maryland', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'New Jersey', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'South Carolina', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'Wyoming', link: '/'},
        ],
      },
      {
        level: 2,
        title: 'By Investment',
        icon: 'investmentIcon',
        link: 'investment',
        selected: false,
        disabled: false,
        children: [
          { level: 3, selected: false, disabled: false, title: 'under $10,000', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'under $60,000', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'under $200,000', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'under $20,000', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'under $70,000', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'under $300,000', link: '/', fire: true },
          { level: 3, selected: false, disabled: false, title: 'under $30,000', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'under $80,000', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'under $400,000', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'under $40,000', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'under $90,000', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'under $500,000', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'under $50,000', link: '/'},
          { level: 3, selected: false, disabled: false, title: 'under $100,000', link: '/', fire: true },
          { level: 3, selected: false, disabled: false, title: 'Any amount', link: '/'},
        ],
      }
    ]
  },
  {
    level: 1,
    title: 'Top 100 Franchise',
    open: false,
    selected: false,
    disabled: false,
    link: 'top-100-franchise',
  },
  {
    level: 1,
    title: 'Resources',
    open: false,
    selected: false,
    disabled: false,
    link: 'resources',
  },
];

export const userTest = { name: 'Kaytie Cayton', avatar: './assets/images/profile.png' };

